import {
	COMPANY_HOTEL_PRICE_RECOMMENDATION_SETTINGS_FRAGMENT,
	COMPANY_HOTEL_SETTINGS_FRAGMENT,
} from '@app/model/company_hotel/service/CompanyHotelGraphQLFragments';
import { gql } from 'graphql-request';
import GraphQL from '@app/model/_common/service/GraphQL';


export const SAVE_COMPANY_HOTEL_CALENDAR_TABLE_SETTINGS_MUTATION: GraphQL = {
	name: 'saveCalendarTableSettings',
	gql: gql`
      ${COMPANY_HOTEL_SETTINGS_FRAGMENT}
      mutation saveCalendarTableSettings($companyHotelId: Long!, $input: CalendarTableSettingsInput!) {
          saveCalendarTableSettings(companyHotelId: $companyHotelId, input: $input) {
              ...CompanyHotelSettingsFragment
          }
      }
	`,
};

export const SAVE_COMPANY_HOTEL_CALENDAR_FILTERS_SETTINGS_MUTATION: GraphQL = {
	name: 'saveCalendarFiltersSettings',
	gql: gql`
      ${COMPANY_HOTEL_SETTINGS_FRAGMENT}
      mutation saveCalendarFiltersSettings($companyHotelId: Long!, $input: CalendarFiltersSettingsInput!) {
          saveCalendarFiltersSettings(companyHotelId: $companyHotelId, input: $input) {
              ...CompanyHotelSettingsFragment
          }
      }
	`,
};

export const SAVE_COMPANY_HOTEL_GENERAL_SETTINGS_MUTATION: GraphQL = {
	name: 'saveGeneralSettings',
	gql: gql`
      ${COMPANY_HOTEL_SETTINGS_FRAGMENT}
      mutation saveGeneralSettings($companyHotelId: Long!, $input: CompanyHotelGeneralSettingsInput!) {
          saveGeneralSettings(companyHotelId: $companyHotelId, input: $input) {
              ...CompanyHotelSettingsFragment
          }
      }
	`,
};

export const SAVE_COMPANY_HOTEL_CALENDAR_SETTINGS_MUTATION: GraphQL = {
	name: 'saveCalendarSettings',
	gql: gql`
      ${COMPANY_HOTEL_SETTINGS_FRAGMENT}
      mutation saveCalendarSettings($companyHotelId: Long!, $input: CompanyHotelCalendarSettingsInput!) {
          saveCalendarSettings(companyHotelId: $companyHotelId, input: $input) {
              ...CompanyHotelSettingsFragment
          }
      }
	`,
};

export const SAVE_COMPANY_HOTEL_PRICE_SETTINGS_MUTATION: GraphQL = {
	name: 'savePriceSettings',
	gql: gql`
      ${COMPANY_HOTEL_SETTINGS_FRAGMENT}
      mutation savePriceSettings($companyHotelId: Long!, $input: CompanyHotelPriceSettingsInput!) {
          savePriceSettings(companyHotelId: $companyHotelId, input: $input) {
              ...CompanyHotelSettingsFragment
          }
      }
	`,
};

export const SAVE_COMPANY_HOTEL_AVAILABILITY_SETTINGS_MUTATION: GraphQL = {
	name: 'saveAvailabilitySettings',
	gql: gql`
      ${COMPANY_HOTEL_SETTINGS_FRAGMENT}
      mutation saveAvailabilitySettings($companyHotelId: Long!, $input: CompanyHotelAvailabilitySettingsInput!) {
          saveAvailabilitySettings(companyHotelId: $companyHotelId, input: $input) {
              ...CompanyHotelSettingsFragment
          }
      }
	`,
};


export const SAVE_COMPANY_HOTEL_CALENDAR_EXPORT_SETTINGS_MUTATION: GraphQL = {
	name: 'saveCalendarExportSettings',
	gql: gql`
      ${COMPANY_HOTEL_SETTINGS_FRAGMENT}
      mutation saveCalendarExportSettings($companyHotelId: Long!, $input: CalendarExportSettingsInput!) {
          saveCalendarExportSettings(companyHotelId: $companyHotelId, input: $input) {
              ...CompanyHotelSettingsFragment
          }
      }
	`,
};


export const SAVE_COMPANY_HOTEL_PRICE_RECOMMENDATION_SETTINGS_MUTATION: GraphQL = {
	name: 'saveCompanyHotelPriceRecommendationSettings',
	gql: gql`
      ${COMPANY_HOTEL_PRICE_RECOMMENDATION_SETTINGS_FRAGMENT}
      mutation saveCompanyHotelPriceRecommendationSettings($companyHotelId: Long!, $input: CompanyHotelPriceRecommendationSettingsInput!) {
          saveCompanyHotelPriceRecommendationSettings(companyHotelId: $companyHotelId, input: $input) {
              ...CompanyHotelPriceRecommendationSettingsFields
          }
      }
	`,
};

export const SAVE_HIDDEN_PRICING_ROOM_RATE_TYPES_MUTATION: GraphQL = {
	name: 'saveHiddenPricingRoomRateTypes',
	gql: gql`
      ${COMPANY_HOTEL_PRICE_RECOMMENDATION_SETTINGS_FRAGMENT}
      mutation saveHiddenPricingRoomRateTypes($companyHotelId: Long!, $rateTypes: [String!]!) {
          saveHiddenPricingRoomRateTypes(companyHotelId: $companyHotelId, rateTypes: $rateTypes) {
              ...CompanyHotelPriceRecommendationSettingsFields
          }
      }
	`,
};

